export const environment = {
    production: true,
    recaptcha: {
        siteKey: '6LeyChIqAAAAANbVnmHSXEuW0s6c1kbZl-ycfFJG'
    },
    apiAssetUrl: 'https://www.xipe-angular.xtirs.in/backend',
    apiUrl: 'https://www.xipe-angular.xtirs.in/backend/api/v1'
};
